import { render, staticRenderFns } from "./NotReady.vue?vue&type=template&id=7c5590b3"
import script from "./NotReady.vue?vue&type=script&lang=js"
export * from "./NotReady.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports